<header *ngIf="title">
  <h3>{{ title }}</h3>
</header>

<main class="pwx-4 pwt-7 as-ctr fs-u2 fw-u1 message-text">
  {{ message }}
</main>

<footer class="qq-buttons jc-dsk-ctr">
  <div class="ds-dsk-only">
    <button data-cy="dsk-no-button" mat-raised-button (click)="close(false)">
      No
    </button>

    <button
      data-cy="dsk-yes-button"
      mat-raised-button
      (click)="close(true)"
      color="primary"
    >
      Yes
    </button>
  </div>

  <div class="ds-mbl-only fld-row flg-5">
    <button data-cy="mbl-no-button" mat-button (click)="close(false)">
      NO
    </button>

    <button
      data-cy="mbl-yes-button"
      mat-button
      (click)="close(true)"
      color="primary"
    >
      YES
    </button>
  </div>
</footer>
